export const SORT_NAME = 'sort.name';
export const SORT_LAST_ACTIVITY = 'sort.lastActivity';
